/* eslint-disable sonarjs/no-use-of-empty-return-value */
/* eslint-disable sonarjs/cognitive-complexity */
// eslint-disable-next-line import/no-extraneous-dependencies
// import InfiniteScroll from 'react-infinite-scroll-component';
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Col, Input, message as toaster, Modal } from 'antd';
import styled from 'styled-components';
import { Box, Button, Flex, Text } from 'atoms';
import { approvalTrip, getapprovalList, rejectTrip } from 'store/approvalSlice';
import { getSignedUrl } from 'store/commonSlice';
import { ACL } from 'components/common';
import { SVG } from 'utils';
import useAuth, { getUserType } from 'hooks/useAuth';
import { formatApprovalDate, formatApprovalTime } from 'utils/approvalDateTime';
// import { useQueryParams } from 'hooks';
// import { FilterAtnButton } from 'utils/commonStyled';
// import { getTripListAction } from 'store/pageSlice';

export default function PendingTaskFom({ tabs }) {
	const pendingApprovalFilters = {
		trip_approval_status: 5,
		trip_status: '2',
	};

	// const MainBox = styled(Box)`
	// 	padding: 16px;
	// 	height: 100px;
	// 	gap: 5rem;
	// `;
	console.log(tabs);

	const { Search } = Input;
	const { permissions } = useAuth();

	const LtSearchBar = styled(Search)`
		border: none;
	`;

	const dispatch = useDispatch();
	const [DataSource, SetDataSource] = useState([]);
	const [total_count, SetTotalCount] = useState(0);
	const [limit, SetLimit] = useState(10);
	const [ApproveModal, setApproveModal] = useState(false);
	const [rejectModal, SetrejectModal] = useState(false);
	const [proj_name, setProjectName] = useState('');
	const [projectIds, setProjectIds] = useState('');
	const [remark_reason, setRemarkReason] = useState('');
	const [searchVal, SetsearchVal] = useState(undefined);

	console.log(searchVal);

	useEffect(() => {
		console.log('sdkj');
		console.log('query_str', Search);
		dispatch(getapprovalList({ limit, ...pendingApprovalFilters })).then((res) => {
			SetDataSource(res?.rows);
			SetTotalCount(res?.count);
		});
	}, [Search, dispatch, limit]);

	const fetchMoreData = () => {
		const total_counts = total_count;
		const DSDataaSource = DataSource.length;
		console.log(total_counts, DSDataaSource);
		if (DSDataaSource < total_counts) {
			SetLimit(limit + 10);
			console.log(limit);
			console.log(limit);
			apiFunc();
		} else {
			toaster.error(`End of the page`);
		}
	};

	useEffect(() => {
		console.log(remark_reason);
		console.log(DataSource);
		console.log(limit);
	}, [limit, DataSource, remark_reason]);

	const apiFunc = () => {
		console.log(limit);
		dispatch(getapprovalList({ limit, ...pendingApprovalFilters })).then((resq) => {
			SetDataSource(resq?.rows);
			SetTotalCount(resq?.count);
		});
	};

	const padding35 = {
		padding: '5px 10px',
		width: '130px',
	};
	const padding135 = {
		padding: '5px 10px',
		width: '185px',
	};
	const cardHeader = {
		fontSize: '12px',
		color: '#888383',
		marginBottom: '5px',
	};
	const cardValue = {
		fontSize: '14px',
		color: '#000',
		fontWeight: '500',
		marginTop: '20px',
		maxWidth: '98px',
		overflowWrap: 'anywhere',
	};

	const cardValueData = {
		color: '#000',
		fontWeight: '500',
		marginTop: '20px',
		fontSize: '12px',
	};

	const wid5 = {
		marginRight: '7px',
		lineHeight: '2.2',
	};
	const approvalflex = {
		alignItems: 'center',
		margin: '40px 30px',
	};

	const loadMore = {
		float: 'right',
		paddingTop: '8px',
		marginTop: '5px',
	};

	const tripID = {
		color: '#1cbdf6',
		fontWeight: '800',
	};

	const extra = {
		fontSize: '15px',
		background: '#7ae27a',
		padding: '8px 22px',
		cursor: 'pointer',
		display: 'flex',
	};

	function CheckForPermission() {
		const hasVisibleActionButtons =
			permissions?.update?.includes('approve_trip') ||
			permissions?.update?.includes('reject_trip') ||
			permissions?.update?.includes('all');

		return (
			!hasVisibleActionButtons &&
			getUserType() !== 'admin' &&
			getUserType() !== 'business' &&
			getUserType() !== 'control_tower'
		);
	}

	const DateFormat = 'DD-MM-YYYY';
	const TIME_FORMAT = 'hh:mm a';

	function getLocalDate(date) {
		return formatApprovalDate(date, DateFormat) || '-';
	}

	function getLocalTime(time) {
		return formatApprovalTime(time, TIME_FORMAT);
	}

	const vdgicon = {
		margin: '30px 5px',
	};

	const getTripCard = (item, index) => (
		<Box>
			<Box className="apporval-card" key={index}>
				<Flex>
					<Box style={vdgicon}>
						<Box>
							<SVG.AdhocAppprvalIcons width="26px" />
						</Box>
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> Project Location </Col>
						<Col style={cardValue}> {item?.project_location_code} </Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> City</Col>
						<Col style={cardValue}> {item?.city} </Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> Client name</Col>
						<Col style={cardValue}> {item?.client_name} </Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> Vendor name</Col>
						<Col style={cardValue}> {item?.vendor_name} </Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> Vehicle Info </Col>
						<Col style={cardValue}>
							<Box style={{ lineHeight: '2' }}>
								<Text overFlow="hidden" style={{ fontSize: '12px' }}>
									{item?.vehicle_type}
								</Text>
								<Text overFlow="hidden" style={{ color: '#787272' }}>
									{item?.vehicle_number}
								</Text>
							</Box>
						</Col>{' '}
					</Box>
					<Box style={padding135}>
						{' '}
						<Col style={cardHeader}> Start | End </Col>
						<Col style={cardValueData}>
							{' '}
							<Flex>
								{' '}
								<Box style={wid5}>
									<Text overFlow="hidden" style={{ fontSize: '12px' }}>
										{getLocalDate(item?.start_time)}
									</Text>

									<Text overFlow="hidden" style={{ color: '#787272' }}>
										{getLocalTime(item?.start_time)}
									</Text>
								</Box>
								<Box style={wid5}>
									<Text overFlow="hidden" style={{ fontSize: '12px' }}>
										{getLocalDate(item?.end_time)}
									</Text>

									<Text overFlow="hidden" style={{ color: '#787272' }}>
										{getLocalTime(item?.end_time)}
									</Text>
								</Box>
							</Flex>
						</Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}>Created By </Col>
						<Col style={cardValue}> {item?.created_by_name} </Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> Driver Name </Col>
						<Col style={cardValue}> {item?.info?.driver_name} </Col>{' '}
					</Box>
					<Box style={padding35}>
						{' '}
						<Col style={cardHeader}> Trip ID </Col>
						<Col style={cardValue}>
							{' '}
							<Box style={tripID}> {item?.id} </Box>
						</Col>{' '}
					</Box>
					<Box>
						<Flex style={approvalflex}>
							<Box
								style={{ margin: '10px', cursor: 'pointer' }}
								onClick={() => onNavigate(item?.id)}
							>
								<SVG.EyeIconSVG style={{}} />
							</Box>{' '}
							<Box>
								<ACL action="update" module="reject_trip">
									<Button
										borderRadius="4px"
										style={reject}
										onClick={() =>
											rejectFUn(item?.id, item?.project_location_code)
										}
									>
										Reject
									</Button>
								</ACL>
							</Box>{' '}
							<Box>
								<ACL action="update" module="approve_trip">
									<Button
										borderRadius="4px"
										style={approvalBtn}
										onClick={() =>
											apprFun(item?.id, item?.project_location_code)
										}
									>
										Approve
									</Button>
								</ACL>
							</Box>{' '}
							{CheckForPermission() && (
								<Box style={apps}>
									<Flex style={pendingst}>
										<span style={approvedS}>Pending</span>{' '}
									</Flex>
								</Box>
							)}
						</Flex>
					</Box>
				</Flex>
				<Box>
					<Box style={extra} onClick={() => downloadFile(item?.info?.requirement_proof)}>
						<SVG.MessageIConsAPp style={iconInline} />{' '}
						<span> Extra Requirement : Attachment Available</span>
					</Box>
				</Box>
			</Box>
		</Box>
	);

	const pendingst = {
		background: '#f2d7a5',
		color: '#eb5e0b',
		padding: '5px 20px',
		borderRadius: '4px',
	};

	const apps = {
		padding: '10px 40px',
		textAlign: 'center',
	};
	const approvedS = {
		fontSize: '18px',
	};
	function onNavigate(id) {
		window.location.href = `${window.origin}/trips/${id}`;
	}
	function downloadFile(files) {
		const data = {
			url_type: 'download',
			data: {
				entity: 'trip',
				keys: files,
			},
		};

		dispatch(getSignedUrl(data)).then((res) => {
			console.log(res);
			window.open(res?.data[0]?.url);
		});
	}

	const [focusFalse, SetFoucsFalse] = useState(true);

	const iconInline = { display: 'inline' };
	function rejectFUn(id, project_location_code) {
		setProjectName(project_location_code);
		setProjectIds(id);
		SetrejectModal(true);
		SetFoucsFalse(false);
	}

	function rejectConfirmation() {
		console.log('SDfjsdj');

		if (remark_reason !== '') {
			rejectTrip({ id: projectIds, audit_remarks: remark_reason });
		}
	}

	function apprFun(id, project_location_code) {
		setProjectIds(id);
		setProjectName(project_location_code);
		setApproveModal(true);
	}

	function ApproveConfirmation() {
		setApproveModal(false);
		approvalTrip({ id: projectIds });
	}

	const reject = {
		color: 'red',
		background: '#fff',
		border: '1px solid #de1313',
	};
	const approvalBtn = {
		color: 'green',
		background: '#fff',
		border: '1px solid green',
	};

	function getLenght() {
		const tot = total_count - DataSource.length;
		return tot > 0;
	}

	const rejecthandleCancel = () => {
		SetrejectModal(false);
		setProjectIds('');
		SetFoucsFalse(false);
		setRemarkReason(undefined);
		window.location.reload();
	};
	const apprpveandleCancel = () => {
		setApproveModal(false);
		setProjectIds('');
	};

	// const getProfiles = (item) => getTripCard(item);
	console.log(total_count);
	console.log(DataSource);
	console.log(getLenght());

	const leftShift = {
		float: 'right',
	};
	const boxmodal = {
		width: '100%',
		height: '50px',
		padding: '10px',
	};

	const confirmcontainer = {
		textAlign: 'center',
	};

	const confimPop = {
		justifyContent: 'space-around',
	};
	const billingCant = {
		fontWeight: '600',
		fontSize: '16px',
	};
	const rejectLine = {
		marginTop: '13px',
	};
	const rejectHighlight = {
		color: 'red',
		fontWeight: '600',
	};
	const approveHighlight = {
		color: 'green',
		fontWeight: '600',
	};
	const projectsStyle = {
		fontWeight: '600',
		fontSize: '16px',
		marginBottom: '30px',
		marginTop: '5px',
	};

	function handleCitiesChange(e) {
		console.log(e?.target?.value);
		setRemarkReason(e?.target?.value);
	}

	function searchApproval(val) {
		console.log(val);
		SetsearchVal(val);
		if (val) {
			dispatch(getapprovalList({ limit, ...pendingApprovalFilters, query_str: val })).then(
				(res) => {
					SetDataSource(res?.rows);
					SetTotalCount(res?.count);
				}
			);
		} else {
			dispatch(getapprovalList({ limit, ...pendingApprovalFilters })).then((res) => {
				SetDataSource(res?.rows);
				SetTotalCount(res?.count);
			});
		}
	}

	const remarkReq = {
		color: 'red',
		fontSize: '12px',
	};

	// const [paginateConfig, setpaginateConfig] = useQueryParams({
	// 	search_type: 'approval_entities',
	// });

	function SetFun(e) {
		SetsearchVal(e.target.value);

		const inputElement = document.getElementById('myInput');
		console.log(inputElement);
		inputElement.focus();
	}

	return (
		<Box>
			<Box>
				<Flex justifyContent="space-between" mt={3}>
					<Box flex="0 0 20%" marginRight="10px">
						<LtSearchBar
							placeholder="Search"
							enterButton="Search"
							id="myInput"
							autoFocus={focusFalse}
							value={searchVal}
							allowClear
							onChange={(val) => SetFun(val)}
							onSearch={(val) => searchApproval(val)}
						/>
					</Box>

					<Flex></Flex>
					<Box style={boxmodal}>
						<Box style={leftShift}>Total Items: {DataSource.length}</Box>
					</Box>
				</Flex>

				<div
					style={{
						overflow: 'auto',
					}}
				>
					{/* <InfiniteScroll dataLength={100} next={fetchMoreData} hasMore>
						{DataSource.map((item, index) =>
							// eslint-disable-next-line react/jsx-key
							getTripCard(item, index)
						)}
					</InfiniteScroll> */}
					{DataSource.length > 0 && (
						<Box>
							{' '}
							{DataSource.map((item, index) =>
								// eslint-disable-next-line react/jsx-key
								getTripCard(item, index)
							)}{' '}
						</Box>
					)}
					{DataSource.length === 0 && (
						<Box style={{ textAlign: 'center' }}>
							{' '}
							<Text style={{ color: '#8a3a3', fontSize: '18px' }}> No Data</Text>
						</Box>
					)}
				</div>
				{DataSource.length > 0 && (
					<div style={loadMore}>
						{getLenght && (
							<Button
								onClick={fetchMoreData}
								borderRadius="4px"
								backgroundColor="#18405d"
							>
								Load More ( Next 10 items )
							</Button>
						)}
					</div>
				)}
			</Box>
			<Modal
				width={400}
				title="Reject Confimation"
				open={rejectModal}
				footer={null}
				onCancel={rejecthandleCancel}
			>
				<Box style={confirmcontainer}>
					<Box style={billingCant}>Billing cannot be done!</Box>
					<Box style={rejectLine}>
						{' '}
						Do you want to <span style={rejectHighlight}> Reject </span> this adhoc trip
						for project
					</Box>
					<Box style={projectsStyle}> {proj_name}</Box>
					<Box style={{ textAlign: 'left' }}>Reject Reason:</Box>
					<Box style={projectsStyle}>
						{' '}
						<textarea
							// eslint-disable-next-line jsx-a11y/no-autofocus
							autoFocus
							name="remark"
							style={{
								width: '100%',
							}}
							onChange={(e) => handleCitiesChange(e)}
						/>{' '}
						<div style={remarkReq}> Remake is required</div>
					</Box>

					<Flex style={confimPop}>
						<Box>
							<Button
								borderRadius="4px"
								style={reject}
								onClick={() => rejecthandleCancel()}
							>
								Cancel
							</Button>
						</Box>{' '}
						<Box>
							<Button
								borderRadius="4px"
								style={approvalBtn}
								onClick={() => rejectConfirmation()}
							>
								Submit
							</Button>
						</Box>{' '}
					</Flex>
				</Box>
			</Modal>
			<Modal
				width={400}
				title="Approve Trip"
				open={ApproveModal}
				footer={null}
				onCancel={apprpveandleCancel}
			>
				<Box style={confirmcontainer}>
					<Box style={billingCant}>Approve the Trip</Box>
					<Box style={rejectLine}>
						{' '}
						Do you want to <span style={approveHighlight}> Approve </span> this adhoc
						trip for project
					</Box>
					<Box style={projectsStyle}> {proj_name}</Box>

					<Flex style={confimPop}>
						<Box>
							<Button
								borderRadius="4px"
								style={reject}
								onClick={() => apprpveandleCancel()}
							>
								No
							</Button>
						</Box>{' '}
						<Box>
							<Button
								borderRadius="4px"
								style={approvalBtn}
								onClick={() => ApproveConfirmation()}
							>
								Yes
							</Button>
						</Box>{' '}
					</Flex>
				</Box>
			</Modal>
		</Box>
	);
}

PendingTaskFom.propTypes = {
	tabs: PropTypes.number,
};
